export const useGetFormConfigByMode = (mode: string) => {
  const shouldDisableForm = mode === 'view';
  return { shouldDisableForm };
};
